import type { LinkedAccount, LinkedAccountPlatform } from "@store/linkedAccountSlice";

export interface PlatformAccountGroup {
  platform: LinkedAccountPlatform;
  accounts: LinkedAccount[];
}

export const groupAccountsByPlatform = (items: LinkedAccount[]): PlatformAccountGroup[] => {
  const order: LinkedAccountPlatform[] = [];
  const map = new Map<LinkedAccountPlatform, LinkedAccount[]>();
  for (const account of items) {
    const platform = (account.platform ?? "TIKTOK") as LinkedAccountPlatform;
    if (!map.has(platform)) {
      order.push(platform);
      map.set(platform, []);
    }
    map.get(platform)!.push(account);
  }
  return order.map((platform) => ({ platform, accounts: map.get(platform)! }));
};
